import * as yup from 'yup';
import { VehicleExtraOptionPricingType } from '@carvia/ros-client-types';
import { uniqBy } from 'lodash';

export const extraSchema = (hasQuantityOptions: boolean) =>
  yup.object({
    priceRanges: yup
      .array(
        yup.object({
          fromPrice: yup.number().min(0).required(),
          toPrice: yup.number().min(0).optional().nullable(),
          options: yup
            .array(
              yup.object({
                value: yup.string().min(1).required(),
                pricingType: yup.string().required(),
                price: yup.number().when('pricingType', {
                  is: (val: VehicleExtraOptionPricingType) =>
                    val === VehicleExtraOptionPricingType.FIXED,
                  then: (schema) => schema.required(),
                  otherwise: (schema) => schema.nullable(),
                }),
                pricePerDay: yup
                  .array(
                    yup.object({
                      fromDay: yup.number().min(1).required(),
                      pricePerDay: yup.number().min(0).required(),
                    }),
                  )
                  .when('pricingType', {
                    is: (val: VehicleExtraOptionPricingType) =>
                      val === VehicleExtraOptionPricingType.FIXED_PER_DAY,
                    then: (schema) => schema.min(1).required(),
                    otherwise: (schema) => schema.nullable(),
                  }),
              }),
            )
            .test(
              'no-duplicate-value',
              'Every option of a price range must have a different value',
              (options) => (options?.length ?? '') === uniqBy(options, 'value').length,
            )
            .min(1, 'At least one option is required')
            .required(),
          ...(hasQuantityOptions
            ? {
                maxQuantity: yup.number().min(1).required(),
              }
            : {}),
        }),
      )
      .test('needs-zero-price', 'There must be one price range with fromPrice = 0', (priceRanges) =>
        priceRanges?.some((priceRange) => priceRange.fromPrice === 0),
      )
      .test(
        'no-duplicate-from-price',
        'Every price range must have a different fromPrice',
        (priceRanges) => (priceRanges?.length ?? 0) === uniqBy(priceRanges, 'fromPrice').length,
      )
      .required(),
  });
